import React from 'react'

const Spinner = () => {
    return (
        <div className="column">
            <div className="spinner m-auto"></div>
        </div>
    )
}

export default Spinner